export default function formatBoolean(boolean) {
  return boolean ? 'Sim' : 'Não';
}
